<section class="pbw-panel">
  <!-- Antes de aplicar: la advertencia y la confirmación explícita. -->
  <ng-container *ngIf="!terminado && !aplicando">
    <h2 class="pbs-title">Aplicar los pagos</h2>
    <p class="pbs-lead">Este paso aplica {{ total }} pago(s) en {{ arrendamientosTocados }} arrendamiento(s) y no se deshace desde aquí.</p>

    <div class="pbs-notice">
      <i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
      <div>
        <strong>Se va a aplicar lo que acabas de revisar</strong>
        Cada pago viaja con la huella del impacto que aprobaste: si un arrendamiento cambió mientras revisabas, ese pago
        se rechaza y los demás siguen. Deshacer una aplicación es otro trabajo, con motivo y bitácora.
      </div>
    </div>

    <div class="pbs-confirm">
      <p-checkbox [(ngModel)]="confirmado" [binary]="true" inputId="pbwConfirmarAplicar"></p-checkbox>
      <label for="pbwConfirmarAplicar">Revisé el impacto y quiero aplicar estos {{ total }} pago(s).</label>
    </div>

    <div class="pbs-actions">
      <button pButton type="button" label="Salir" class="p-button-text p-button-secondary pbs-left" (click)="onExit.emit()"></button>
      <button pButton type="button" label="Volver al impacto" icon="fa-solid fa-chevron-left" class="p-button-outlined" (click)="onBack.emit()"></button>
      <button pButton type="button" label="Aplicar" icon="fa-solid fa-check" [disabled]="!confirmado" (click)="aplicar()"></button>
    </div>
  </ng-container>

  <!-- Aplicando: avance real, cancelable. -->
  <div class="pbi-run" *ngIf="aplicando">
    <div class="pbi-run-head">
      <span><i class="fa-solid fa-spinner fa-spin"></i> Aplicando {{ hechos }} de {{ total }}…</span>
      <button pButton type="button" label="Detener" class="p-button-sm p-button-text p-button-secondary" [disabled]="cancelando" (click)="cancelar()"></button>
    </div>
    <p-progressBar [value]="progreso"></p-progressBar>
    <span class="pbs-hint" *ngIf="cancelando">Se detiene al terminar el que está en curso. Lo ya aplicado se queda aplicado.</span>
  </div>

  <!-- Terminado: qué pasó, y la tarjeta de avisos. -->
  <ng-container *ngIf="terminado">
    <h2 class="pbs-title">Listo</h2>
    <p class="pbs-lead">Esto es lo que quedó aplicado.</p>

    <div class="pbs-summary">
      <div class="pbs-stat is-ok">
        <div class="pbs-stat-v">{{ aplicados.length }}</div>
        <div class="pbs-stat-l">Pagos aplicados</div>
      </div>
      <div class="pbs-stat">
        <div class="pbs-stat-v">{{ totalAplicado | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</div>
        <div class="pbs-stat-l">Dinero aplicado</div>
      </div>
      <div class="pbs-stat is-danger" *ngIf="fallidos.length">
        <div class="pbs-stat-v">{{ fallidos.length }}</div>
        <div class="pbs-stat-l">No se pudieron aplicar</div>
      </div>
    </div>

    <div class="pbs-notice is-danger" *ngIf="fallidos.length">
      <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
      <div>
        <strong>{{ fallidos.length }} pago(s) quedaron registrados y sin aplicar</strong>
        Su dinero sigue disponible. Aplícalos desde el arrendamiento, uno a uno, donde vas a ver por qué falló cada uno.
      </div>
    </div>

    <div class="pbs-table-wrap" *ngIf="fallidos.length">
      <table class="pbs-table">
        <thead>
          <tr>
            <th>Cliente</th>
            <th class="num">Monto</th>
            <th>Qué pasó</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of fallidos" class="is-error">
            <td>{{ r.clientName }}</td>
            <td class="num">{{ r.amount | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</td>
            <td>{{ r.applyError }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- D2 · La tarjeta de avisos. Un mensaje por cliente, todo o nada, y hay que pedirlo. -->
    <div class="pbn-card" *ngIf="puedeAvisar">
      <div class="pbn-head">
        <i class="fa-solid fa-comment-sms" aria-hidden="true"></i>
        <div>
          <strong>Avisarle a los clientes</strong>
          <p>
            Un SMS por cliente —uno solo, aunque tenga varios pagos en esta carga— a las {{ clientesAvisados }} persona(s)
            cuyos pagos se aplicaron. Se manda a todos o a ninguno, y una sola vez: un mensaje enviado no se puede retirar.
          </p>
        </div>
      </div>

      <div class="pbn-msg">«Rendafin: Pago recibido. Gracias por su preferencia.»</div>

      <div class="pbs-confirm">
        <p-checkbox [(ngModel)]="confirmadoAviso" [binary]="true" inputId="pbwConfirmarAviso"></p-checkbox>
        <label for="pbwConfirmarAviso">Quiero avisarle a estos {{ clientesAvisados }} cliente(s).</label>
      </div>

      <div class="pbs-error" *ngIf="avisoError">
        <i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
        <span>{{ avisoError }}</span>
      </div>

      <button pButton type="button" label="Mandar el aviso" icon="fa-solid fa-paper-plane" class="pbn-send" [disabled]="!confirmadoAviso" [loading]="avisando" (click)="avisar()"></button>
    </div>

    <div class="pbs-notice" [class.is-ok]="!state.notice.failed" [class.is-danger]="!!state.notice.failed" *ngIf="state.notice">
      <i class="fa-solid" [class.fa-check]="!state.notice.failed" [class.fa-triangle-exclamation]="!!state.notice.failed" aria-hidden="true"></i>
      <div>
        <strong>Aviso mandado a {{ state.notice.sent }} de {{ state.notice.total }} cliente(s)</strong>
        <ng-container *ngIf="state.notice.failed">A estos no se les pudo avisar. Su pago sí quedó aplicado.</ng-container>
        <ul class="pbn-failed" *ngIf="state.notice.failed">
          <li *ngFor="let d of state.notice.recipients">
            <ng-container *ngIf="!d.sent">{{ d.clientName }} — {{ d.reason }}</ng-container>
          </li>
        </ul>
      </div>
    </div>

    <div class="pbs-notice" *ngIf="state.noticeAlreadySent">
      <i class="fa-solid fa-comment-slash" aria-hidden="true"></i>
      <div>
        <strong>A este lote ya se le mandó su aviso</strong>
        Salió el {{ state.noticeAlreadySent.sentAt | date: 'dd/MM/yyyy HH:mm' }} a {{ state.noticeAlreadySent.sentTo }} cliente(s). No se puede volver a mandar.
      </div>
    </div>

    <div class="pbs-actions">
      <button pButton type="button" label="Terminar" icon="fa-solid fa-check" (click)="onExit.emit()"></button>
    </div>
  </ng-container>
</section>
